import { Main } from '@shared/models/Main.model';

export class Country extends Main {
  id: number = -1;
  name: string = '';
  code: string = '';
  [key: string]: any;
}
